var _rect, _rect2, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _g3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 223,
    viewBox: "0 0 443 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 442,
    height: 222,
    rx: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 442,
    height: 222,
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.522 184.881C264.056 189.87 260.061 192.802 257.001 195.016C227.166 216.606 193.06 210.383 182.516 208.256C165.503 204.825 151.142 202.404 138.804 190.323C110.767 162.872 112.131 105.606 133.554 70.1326C136.095 65.9264 157.486 31.5629 191.665 26.7207C192.501 26.6023 193.125 26.5349 193.671 26.4722C198.958 25.8654 231.724 22.6634 258.441 46.9212C262.265 50.3936 268.42 56.657 274.127 66.2095C294.995 101.138 295.061 155.235 268.522 184.881Z",
    fill: "url(#paint0_linear_1315_294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.996 121.628C151.996 121.628 152.388 103.776 144.801 98.9985C137.214 94.2206 122.789 91.2335 122.248 65.6005C121.931 50.5937 121.589 44.0325 121.359 41.1716C121.269 40.0555 122.185 39.1548 123.2 39.3621C130.386 40.829 153.728 46.8672 158.622 64.1335C164.424 84.6029 151.996 121.628 151.996 121.628Z",
    fill: "url(#paint1_linear_1315_294)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.757 46.494C136.645 54.1176 145.765 67.6096 150.626 81.1018C151.25 83.3254 153.075 88.054 153.868 96.4557C154.576 103.463 154.224 110.867 153.366 115.769C153.311 116.078 153.036 116.282 152.75 116.223C152.258 116.122 152.323 115.549 152.328 115.567C153.308 107.193 152.901 96.77 150.655 87.3655C147.785 75.8179 141.384 64.6221 134.763 55.1264L134.081 54.1913C128.952 47.052 127.872 46.9994 128.351 46.5018C128.465 46.3842 128.642 46.3832 128.757 46.494Z",
    fill: "#7D97F4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 155.95C165.214 156.495 154.47 141.853 151.104 118.856C149.518 108.02 149.498 94.4423 143.802 89.21C139.061 84.8554 122.93 87.6046 117.651 88.6494C116.992 88.78 116.77 89.6829 117.283 90.1502C119.814 92.454 125.229 97.8882 126.64 103.365C128.499 110.583 134.832 115.175 140.501 116.417C146.17 117.66 149.324 118.866 152.086 128.691C154.848 138.517 161.271 154.4 164.188 155.95Z",
    fill: "#7D97F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.075 91.6994C131.809 92.005 139.038 95.3343 142.706 101.579L143.052 102.175C143.852 103.572 148.384 113.505 150.901 121.739C150.933 121.842 150.881 121.953 150.787 121.987C150.626 122.045 150.545 121.853 150.561 121.87C148.807 117.218 146.288 111.321 144.282 106.91C142.131 102.098 140.625 98.839 135.718 95.7172C130.256 92.3553 125.038 92.0092 125.054 92.0126C124.974 92.0038 124.916 91.9267 124.925 91.8404C124.932 91.7574 124.999 91.6961 125.075 91.6994Z",
    fill: "#91B3FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.765 200.032C283.765 201.693 282.51 203.052 280.976 203.052H130.16C128.626 203.052 127.371 201.693 127.371 200.032L126.116 106.104C126.116 104.443 127.922 101.201 131.231 101.445L278.625 97.3116C280.549 97.2576 282.41 98.0604 283.773 99.5327C285.136 101.005 285.882 103.018 285.836 105.102L283.765 200.032Z",
    fill: "url(#paint2_linear_1315_294)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.012 197.135C281.012 198.708 279.824 199.995 278.373 199.995H133.797C132.346 199.995 131.159 198.708 131.159 197.135L129.974 111.867C130.114 106.735 134.265 104.891 136.781 105L278.049 100.893C279.401 100.853 280.709 101.417 281.666 102.453C282.624 103.489 283.146 104.905 283.113 106.371L281.012 197.135Z",
    fill: "url(#paint3_linear_1315_294)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.721 156.477C132.585 156.477 132.474 156.359 132.472 156.211L132.378 149.296C132.376 149.147 132.486 149.025 132.624 149.022C132.757 149.014 132.874 149.139 132.876 149.288L132.97 156.203C132.972 156.352 132.862 156.475 132.725 156.477H132.721Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.491 139.531C132.356 139.531 132.245 139.413 132.243 139.266L131.884 112.781C131.891 111 132.398 109.578 133.389 108.548C135.191 106.677 138.008 106.771 138.127 106.776L183.236 105.464C183.372 105.451 183.488 105.578 183.492 105.727C183.496 105.876 183.387 106 183.25 106.004L138.126 107.316C137.997 107.31 135.385 107.223 133.734 108.938C132.843 109.862 132.389 111.154 132.382 112.778L132.741 139.258C132.743 139.407 132.633 139.529 132.495 139.531C132.494 139.531 132.493 139.531 132.491 139.531Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M137.528 192.405C137.68 185.357 137.623 122.949 137.25 117.56C136.877 112.17 144.623 111.159 156.514 110.552C168.406 109.946 268.743 107.544 271.326 107.317C277.133 106.807 278.335 116.214 277.754 136.635C277.318 151.977 276.594 177.25 276.262 188.873C276.163 192.333 273.553 195.079 270.358 195.089C246.213 195.161 153.672 195.448 147.511 195.647C140.422 195.876 137.468 195.199 137.528 192.405Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M292.192 210.849H122.002C119.907 210.849 118.194 208.992 118.194 206.722C118.194 204.453 119.907 202.596 122.002 202.596H292.192C294.287 202.596 296 204.453 296 206.722C296 208.992 294.287 210.849 292.192 210.849Z",
    fill: "url(#paint4_linear_1315_294)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M258.497 40.2243L157.328 39.553C154.004 39.5309 151.344 42.5408 151.509 46.1396L158.469 201.913H271.051L277.302 62.7379L258.497 40.2243Z",
    fill: "#91B3FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M262.704 62.0706C259.408 61.945 256.875 58.8668 257.135 55.3042L258.219 40.4296L277.322 62.6466L262.704 62.0706Z",
    fill: "url(#paint5_linear_1315_294)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M209.512 70.131C217.827 70.0871 249.748 69.8568 257.808 69.7984C258.825 69.791 259.629 70.9367 259.585 72.3271C259.543 73.6507 258.743 74.7087 257.775 74.7218L209.5 75.3745C208.57 75.3871 207.798 74.4284 207.718 73.1628L207.698 72.8427C207.607 71.3956 208.449 70.1365 209.512 70.131Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M209.104 81.0576C217.418 81.0136 249.339 80.7834 257.4 80.725C258.417 80.7176 259.221 81.8633 259.176 83.2537C259.134 84.5773 258.335 85.6353 257.367 85.6484L209.092 86.3011C208.162 86.3136 207.39 85.355 207.31 84.0894L207.29 83.7692C207.199 82.3222 208.04 81.0632 209.104 81.0576Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M172.978 96.4563C187.004 96.467 240.848 96.4463 254.445 96.4408C256.16 96.4401 257.552 97.5917 257.521 98.9825C257.492 100.306 256.177 101.36 254.544 101.367L173.123 101.702C171.555 101.709 170.222 100.745 170.048 99.478L170.004 99.1575C169.805 97.7091 171.185 96.455 172.978 96.4563Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M172.33 107.924C183.248 107.872 225.16 107.614 235.744 107.548C237.079 107.54 238.155 108.685 238.122 110.076C238.091 111.4 237.06 112.459 235.79 112.472L172.409 113.169C171.189 113.182 170.157 112.224 170.03 110.958L169.998 110.638C169.852 109.19 170.934 107.93 172.33 107.924Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M172.84 122.938C186.866 122.949 240.71 122.928 254.307 122.923C256.022 122.922 257.414 124.074 257.383 125.464C257.354 126.788 256.039 127.842 254.406 127.848L172.985 128.184C171.417 128.191 170.084 127.227 169.91 125.96L169.866 125.639C169.667 124.191 171.047 122.937 172.84 122.938Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M171.62 134.597C182.589 134.618 224.7 134.64 235.334 134.645C236.675 134.645 237.75 135.798 237.709 137.188C237.671 138.512 236.63 139.564 235.353 139.57L171.671 139.842C170.445 139.847 169.413 138.882 169.293 137.615L169.262 137.295C169.124 135.847 170.217 134.594 171.62 134.597Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M172.149 149.96C186.175 149.971 240.019 149.95 253.615 149.945C255.33 149.944 256.722 151.096 256.692 152.487C256.662 153.811 255.347 154.864 253.715 154.871L172.294 155.207C170.725 155.213 169.392 154.249 169.219 152.982L169.175 152.662C168.976 151.213 170.355 149.959 172.149 149.96Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M171.302 161.481C182.271 161.503 224.382 161.524 235.015 161.529C236.356 161.53 237.432 162.682 237.391 164.073C237.353 165.396 236.311 166.449 235.035 166.454L171.353 166.726C170.126 166.731 169.095 165.766 168.974 164.5L168.944 164.179C168.806 162.731 169.899 161.478 171.302 161.481Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M172.978 176.669C187.004 176.68 240.848 176.659 254.445 176.653C256.16 176.653 257.552 177.804 257.521 179.195C257.492 180.519 256.177 181.572 254.544 181.579L173.123 181.915C171.555 181.921 170.222 180.957 170.048 179.69L170.004 179.37C169.805 177.922 171.185 176.667 172.978 176.669Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M172.185 189.437C183.015 189.438 224.594 189.378 235.093 189.363C236.418 189.361 237.48 190.512 237.442 191.902C237.405 193.226 236.378 194.28 235.117 194.288L172.24 194.682C171.029 194.69 170.01 193.727 169.889 192.46L169.859 192.14C169.721 190.692 170.8 189.437 172.185 189.437Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.443 74.5247L179.043 85.6877H174.67L185.796 50.1978H190.898L202.073 85.6877H197.554L194.056 74.5247H182.443ZM193.181 70.9442L189.975 60.7289C189.245 58.4121 188.76 56.3059 188.274 54.2523H188.177C187.691 56.3586 187.156 58.5175 186.525 60.6763L183.318 70.9442H193.181Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.193 218.29C194.096 218.29 193.997 218.267 193.902 218.219C193.527 218.028 193.354 217.514 193.515 217.071L209.003 174.481C209.165 174.038 209.599 173.833 209.974 174.023C210.348 174.214 210.521 174.728 210.36 175.171L194.872 217.762C194.752 218.092 194.479 218.29 194.193 218.29Z",
    fill: "url(#paint6_linear_1315_294)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M211.641 218.29C211.355 218.29 211.083 218.092 210.963 217.761L195.474 175.171C195.313 174.728 195.486 174.214 195.861 174.023C196.235 173.833 196.67 174.037 196.831 174.48L212.319 217.071C212.481 217.514 212.308 218.028 211.933 218.218C211.838 218.267 211.739 218.29 211.641 218.29Z",
    fill: "url(#paint7_linear_1315_294)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.121 218.29C260.024 218.29 259.925 218.267 259.83 218.218C259.455 218.028 259.282 217.514 259.443 217.071L274.932 174.48C275.093 174.037 275.527 173.833 275.902 174.023C276.276 174.214 276.45 174.728 276.288 175.171L260.8 217.761C260.68 218.092 260.407 218.29 260.121 218.29Z",
    fill: "url(#paint8_linear_1315_294)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M277.569 218.29C277.283 218.29 277.011 218.092 276.891 217.761L261.402 175.171C261.241 174.728 261.414 174.214 261.789 174.023C262.163 173.833 262.598 174.037 262.759 174.48L278.247 217.071C278.409 217.514 278.236 218.028 277.861 218.218C277.766 218.267 277.667 218.29 277.569 218.29Z",
    fill: "url(#paint9_linear_1315_294)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M251.565 189.59H249.734V211.052H251.565V189.59Z",
    fill: "url(#paint10_linear_1315_294)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.669 211.466H242.63V211.373C242.63 210.711 243.125 210.174 243.736 210.174H257.477C258.136 210.174 258.669 210.752 258.669 211.466Z",
    fill: "url(#paint11_linear_1315_294)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M261.05 188.845C261.05 190.019 260.164 190.979 259.08 190.979H242.853C241.77 190.979 240.884 190.019 240.884 188.845V186.915C240.884 185.741 241.77 184.781 242.853 184.781H259.08C260.164 184.781 261.05 185.741 261.05 186.915V188.845Z",
    fill: "url(#paint12_linear_1315_294)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M237.131 175.279C237.131 175.279 234.41 175.737 231.35 177.953C230.869 178.302 230.605 178.91 230.677 179.533C231.043 182.678 232.55 192.857 237.517 202.798C237.779 203.323 237.854 203.933 237.738 204.516L236.875 208.868L235.275 210.494H239.397L242.142 202.445L240.968 202.043C240.058 201.731 239.434 200.824 239.417 199.79L239.28 191.155C239.397 187.309 237.103 184.654 237.103 184.654L243.686 184.307L237.131 175.279Z",
    fill: "url(#paint13_linear_1315_294)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M233.666 211.279C233.29 211.812 237.706 212.514 239.937 211.35C239.937 211.35 243.029 205.519 243.029 202.516C243.029 202.516 242.784 201.904 240.968 202.043C240.968 202.043 239.93 208.947 238.833 209.721C237.737 210.494 235.766 209.799 235.766 209.799C235.766 209.799 234.219 210.494 233.666 211.279Z",
    fill: "url(#paint14_linear_1315_294)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M242.853 184.781C242.818 184.715 235.766 183.862 235.766 183.862C235.766 183.862 235.997 186.186 235.275 189.385C234.554 192.584 224.199 206.444 224.199 206.444L225.285 210.174C221.928 211.441 218.626 211.644 215.377 210.82L222.105 206.444C222.105 206.444 228.402 183.187 232.26 179.038L239.329 176.388L242.853 184.781Z",
    fill: "url(#paint15_linear_1315_294)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M258.67 171.248C258.67 171.248 262.733 177.798 263.066 180.786C263.4 183.774 261.953 184.988 257.69 185.188C253.426 185.388 242.045 185.385 242.045 185.385L232.331 176.388C232.331 176.388 239.41 173.65 241.25 172.876C243.091 172.102 258.67 171.248 258.67 171.248Z",
    fill: "url(#paint16_linear_1315_294)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.875 208.918C224.875 208.918 226.043 210.145 225.254 211.51C225.254 211.51 215.994 213.289 213.48 212.482C213.48 212.482 214.002 211.191 216.833 209.721L216.624 209.895C216.36 210.114 216.515 210.573 216.848 210.552C218.713 210.437 222.574 210.066 224.875 208.918Z",
    fill: "url(#paint17_linear_1315_294)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M244.826 132.868C245.46 132.753 247.794 132.442 248.18 133.959C248.231 134.16 248.462 134.227 248.605 134.088C249.341 133.375 251.077 132.033 252.979 132.979C254.659 133.815 254.504 135.554 254.214 136.621C254.144 136.879 254.403 137.093 254.609 136.943C256.074 135.873 259.452 133.963 261.616 137.112C263.633 140.049 261.987 142.087 260.88 143.014C260.693 143.17 260.782 143.493 261.017 143.518C261.825 143.604 262.938 144.086 263.45 145.958C264.253 148.893 259.286 151.331 258.701 151.607C258.664 151.625 258.624 151.632 258.584 151.63L248.551 151.072C248.473 151.068 248.4 151.026 248.353 150.958L242.198 141.972C242.149 141.899 242.134 141.805 242.158 141.719L244.62 133.064C244.649 132.961 244.728 132.885 244.826 132.868Z",
    fill: "url(#paint18_linear_1315_294)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M247.681 170.381C247.681 170.381 242.949 165.498 240.62 162.264C239.361 160.516 238.965 158.215 239.548 156.089C240.611 152.206 242.501 148.185 242.673 147.559C242.937 146.6 248.243 146.639 248.243 146.639C248.243 146.639 258.683 153.983 262.785 166.422L258.178 167.976C258.178 167.976 255.452 163.02 252.759 159.869C252.759 159.869 257.419 166.541 257.583 169.272L247.681 170.381Z",
    fill: "url(#paint19_linear_1315_294)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M242.031 142.197C242.087 142.397 243.472 147.372 243.58 147.475C243.688 147.578 246.617 147.749 247.995 146.728L245.657 141.423L242.031 142.197Z",
    fill: "url(#paint20_linear_1315_294)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M238.118 135.18C238.118 135.18 236.962 137.841 238.109 141.985C239.257 146.129 241.315 146.556 242.655 145.587C243.995 144.617 245.746 142.863 246.065 139.156C246.384 135.448 239.701 131.819 238.118 135.18Z",
    fill: "url(#paint21_linear_1315_294)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M243.515 138.827C243.515 138.827 241.389 133.199 237.86 136.54L237.554 137.959C237.554 137.959 234.317 136.84 235.484 133.669C236.65 130.499 240.506 127.989 243.939 130.187C247.372 132.384 248.597 135.34 248.325 138.253C248.053 141.166 246.063 140.098 246.063 140.098C246.063 140.098 245.736 137.939 244.799 137.525C243.861 137.111 243.835 138.737 243.835 138.737L243.515 138.827Z",
    fill: "url(#paint22_linear_1315_294)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M244.299 138.921C244.299 138.921 243.191 136.035 244.862 135.989C246.533 135.943 245.772 138.766 245.409 139.793L244.299 138.921Z",
    fill: "url(#paint23_linear_1315_294)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M238.041 170.744L241.517 167.113L246.327 169.314C246.327 169.314 251.114 170.118 253.854 169.314C256.593 168.51 256.593 168.51 256.593 168.51L262.785 166.422L263.757 169.4C264.004 170.156 263.756 170.995 263.153 171.46C262.617 171.873 261.989 172.326 261.589 172.516C260.774 172.902 241.49 172.248 241.49 172.248L238.041 170.744Z",
    fill: "url(#paint24_linear_1315_294)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M251.197 172.456C251.182 172.457 251.166 172.457 251.151 172.457L230.984 172.433C230.486 172.433 230.082 171.994 230.083 171.454C230.083 170.914 230.489 170.467 230.986 170.477L251.153 170.501C251.651 170.501 252.055 170.94 252.054 171.48C252.054 172.003 251.674 172.43 251.197 172.456Z",
    fill: "url(#paint25_linear_1315_294)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M212.856 152.613H229.65C230.889 152.613 232.017 153.388 232.545 154.602L240.31 172.444H219.438C218.64 172.444 217.923 171.916 217.629 171.111L211.608 154.601C211.26 153.647 211.909 152.613 212.856 152.613Z",
    fill: "url(#paint26_linear_1315_294)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M224.688 161.761C225.052 162.986 224.783 164.177 224.087 164.419C223.392 164.662 222.533 163.865 222.169 162.64C221.805 161.414 222.074 160.224 222.769 159.982C223.465 159.739 224.324 160.536 224.688 161.761Z",
    fill: "#91B3FA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M279.382 173.254C279.433 173.007 279.364 172.75 279.193 172.556C279.023 172.361 278.768 172.248 278.5 172.248H187.67C187.318 172.248 186.989 172.417 186.799 172.697C186.609 172.977 186.584 173.328 186.732 173.629L187.716 175.634C187.941 176.094 188.43 176.388 188.967 176.388H277.877C278.377 176.388 278.807 176.054 278.902 175.592L279.382 173.254Z",
    fill: "url(#paint27_linear_1315_294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1315_294",
    x1: 304.842,
    y1: 240.87,
    x2: 173.51,
    y2: 111.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1315_294",
    x1: 121.353,
    y1: 80.48,
    x2: 160.165,
    y2: 80.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1315_294",
    x1: 191.793,
    y1: 195.831,
    x2: 232.91,
    y2: 82.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1315_294",
    x1: 303.289,
    y1: 94.999,
    x2: -159.47,
    y2: 330.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1315_294",
    x1: 215.679,
    y1: 93.7832,
    x2: 205.06,
    y2: 212.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1315_294",
    x1: 269.855,
    y1: 48.99,
    x2: 242.663,
    y2: 77.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1315_294",
    x1: 212.62,
    y1: 140.512,
    x2: 191.51,
    y2: 234.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1315_294",
    x1: 214.497,
    y1: 140.936,
    x2: 193.388,
    y2: 234.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1315_294",
    x1: 275.809,
    y1: 154.769,
    x2: 254.7,
    y2: 248.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1315_294",
    x1: 277.687,
    y1: 155.192,
    x2: 256.578,
    y2: 248.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1315_294",
    x1: 235.71,
    y1: 229.398,
    x2: 259.534,
    y2: 189.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1315_294",
    x1: 240.002,
    y1: 231.988,
    x2: 263.825,
    y2: 192.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1315_294",
    x1: 231.073,
    y1: 226.6,
    x2: 254.896,
    y2: 187.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1315_294",
    x1: 244.551,
    y1: 219.568,
    x2: 237.283,
    y2: 192.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1315_294",
    x1: 238.632,
    y1: 202.082,
    x2: 236.385,
    y2: 233.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1315_294",
    x1: 231.474,
    y1: 193.103,
    x2: 273.067,
    y2: 173.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1315_294",
    x1: 225.003,
    y1: 178.317,
    x2: 255.784,
    y2: 178.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1315_294",
    x1: 220.151,
    y1: 200.775,
    x2: 217.903,
    y2: 232.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1315_294",
    x1: 238.108,
    y1: 127.85,
    x2: 266.982,
    y2: 151.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1315_294",
    x1: 208.097,
    y1: 224.788,
    x2: 256.867,
    y2: 161.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1315_294",
    x1: 246.238,
    y1: 152.982,
    x2: 244.631,
    y2: 143.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1315_294",
    x1: 237.12,
    y1: 140.479,
    x2: 251.702,
    y2: 138.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1315_294",
    x1: 236.382,
    y1: 129.974,
    x2: 265.256,
    y2: 153.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1315_294",
    x1: 236.947,
    y1: 139.088,
    x2: 251.528,
    y2: 137.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1315_294",
    x1: 254.128,
    y1: 169.53,
    x2: 279.939,
    y2: 169.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1315_294",
    x1: 254.619,
    y1: 166.649,
    x2: 238.375,
    y2: 171.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1315_294",
    x1: 232.627,
    y1: 155.274,
    x2: 220.118,
    y2: 167.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1315_294",
    x1: 231.969,
    y1: 178.608,
    x2: 210.86,
    y2: 272.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIcon);
export default __webpack_public_path__ + "static/media/CourseIcon.47b1c79ac24455bc0a3c7f476534071f.svg";
export { ForwardRef as ReactComponent };